import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html'
})
export class PagingComponent implements OnInit {
  @Input() totalPages: number;
  @Input() currentPage: number;
  @Input() displayPages: number;
  @Input() prevPage = 1;
  @Input() nextPage = 2;

  constructor() { }

  ngOnInit() {
  }

}
